import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatTableDataSource, MatPaginator, MatDialogRef, MatDialog } from '@angular/material';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_BASE_URL } from '../../../environments/environment';
import { Router } from '@angular/router';
import moment from 'moment';
import _ from 'lodash'
import { SmsDialogComponent } from '../sms-dialog/sms.component';
import { UpdateOtherTransDialogComponent } from '../update-other-trans-dialog/update-other-trans-dialog.component';
import { StaffDetailDialogComponent } from '../../staffs/staff-detail-dialog/staff-detail-dialog.component';
import { HOURS, MINUTES15, MINUTES1 } from '../../common/constants';
import { BaseComponent } from '../../base.component';
import { getAreaSession, saveAreaSession } from '../../common/utils';

export interface Staff {
  nameStaff: string;
  numberPhoneStaff: string;
  numberMobilePhoneStaff: string;
  staffLatitude: string;
}

@Component({
  selector: 'app-operation-dialog',
  templateUrl: './operation-dialog.component.html',
  styleUrls: ['./operation-dialog.component.less']
})
export class OperationDialogComponent extends BaseComponent implements OnInit {

  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  // 代勤登録する日付
  day: string = moment(this.data['day']).format('YYYY-MM-DD');
  // スポット登録
  spot = false;
  // 画面表示用日付
  dayForDisp: string = moment(this.data['day']).format('YYYY/MM/DD');
  // 清掃員一覧テーブルのデータソース
  dataSource = new MatTableDataSource();
  // 清掃員一覧の全レコードの件数
  dataSourceLength = 0;
  // ページネーター
  @ViewChild(MatPaginator) paginator: MatPaginator;
  // 絞込み清掃員名
  filterName = "";
  // 絞込み清掃員名カナ
  filterNameKana = "";
  // 絞込み清掃員住所
  filterSiteName = "";
  // 絞込みエリアドロップダウン
  areas = [];
  // 絞込みエリア
  areaIds = [];
  // カラム名
  columnDefs = [
    'name',
    'numberPhone',
    'numberMobilePhone',
    'canInstead'
  ];
  // チェックボックス「実績あり」
  hasWorked = false;
  // チェックボックス「代勤経験者」
  hasExperience = false;
  // チェックボックス「空き清掃員」
  freeStaff = false;
  // チェックボックス「住所の近い順」
  position = false;
  // チェックボックス「代勤不可を除く」
  canInstead = false;
  // 物件の緯度経度が取れない場合のメッセージ
  noPositionMsg = '';
  // 代勤者
  workInsteads = [];
  // 代勤ステータスドロップダウン
  statusChoices = [
    {key: 'unknown', value: '未登録', text: '未登録'},
    {key: 'alreadyregistered', value: '登録済み', text: '代勤確定'}, // 文言変更（登録済み➡代勤確定）2025-05
    {key: 'ok', value: '●：代勤OK', text: '●：前日確認OK'}, // 文言変更（代勤OK➡●：前日確認OK）2025-05
    {key: 'ng', value: '×：代勤行けない', text: '×：代勤行けない'},
    {key: 'nocontact', value: '×：連絡とれず', text: '×：連絡とれず'},
    {key: 'request', value: '復帰確認', text: '復帰確認'},
    {key: 'cantReturn', value: '復帰不可・連絡取れず', text: '復帰不可・連絡取れず'},
    {key: 'holiday', value: '休み取り消し', text: '休み取り消し'},
  ];
  // メモ
  note = "";
  // 物件名
  siteName = "";
  // 物件住所
  siteAddress = "";
  // GoogleMap URL
  routeMap = "";
  // 休み種別
  holidayStatus = null;

  // 代勤の最終更新者
  operationCreatedUser = "";
  // 代勤の最終更新日
  operationCreatedDate = "";

  // この行にあと何時間の確定代勤が要るか（稼働管理の SQL が要手配と同じ材料で出した need_hours。要手配の行は > 0、そうでなければ 0）
  needHours = 0;

  // 初出勤の日か（稼働管理の SQL の is_first_day。新規入社の人の、入社日以降で勤務がある最初の日）
  // 引継ぎ・指導の代勤を登録する日なので、本人以外の代勤者を追加したときは「引継・指導」を最初から ON にする。スポット作業のダイアログでは見ない
  isFirstDay = false;

  // この契約の月〜日の勤務（清掃員がいれば雇用指示、欠員なら契約詳細。/sites/operationDialog の1行目）
  schedule: any = null;
  // 契約詳細の時間指定（有／無）。稼働管理と同じく、開いた日に効いている契約の値
  specificTime = '';
  // 通常清掃員の予定勤務開始時間
  startTime = "";
  // 通常清掃員の予定勤務終了時間
  endTime = "";
  // 時間ドロップダウン
  hours: number[] = HOURS;
  // 分ドロップダウン
  minutes: string[] = MINUTES15;
  // 通勤時間
  commuteMinutes: number[] = MINUTES1;

  // 「変更を保存」ボタン　活性:true、非活性:false
  saveDisabled:boolean = false;
  // 月の契約時間を超えないかの確認で数える代勤の状況（確定＝●OK・休み取り消し。月次確認の時間差分と同じ。引継ぎ・指導とスポットは数えない）
  okStatus = ['●：代勤OK', '休み取り消し'];
  // 既に登録している実働時間
  existingWorkingHours = 0;
  // 複数日登録画面
  multipleDay = false;

  // 画面表示　初期値：連日
  displaySpecifyDate = 'consecutive';
  // 複数日選択
  daysSelected: any[] = [];
  daysArray: any[] = [];
  // 選択した日（表示用）
  days:string = '';
  // 曜日ドロップダウン
  weekly = [
    {key: 1, value: '月曜日'},
    {key: 2, value: '火曜日'},
    {key: 3, value: '水曜日'},
    {key: 4, value: '木曜日'},
    {key: 5, value: '金曜日'},
    {key: 6, value: '土曜日'},
    {key: 0, value: '日曜日'}
  ];
  // 選択した曜日
  week = [];
  // 開始日
  start: Date = new Date(this.data['day']);
  // 終了日
  end: Date = new Date(this.data['day']);
  // tbl_operation_noteに保存するデータ
  operationNote: any[] = [];
  // 更新した代勤ID
  updateOperationId = [];
  // 削除されたデータ
  remove = [];
  // 物件概要書の警報
  isAlarm = '';
  // GoogleMapの起点と次の目的地対象となる代勤データ
  routStatus = ['●：代勤OK', '休み取り消し', 'スポット作業']

  maxWage = 1500;
  // 最低賃金マスタ（営業所 → 適用開始日の順。東京・千葉の両方）
  minWageList = [];
  // 画面に出す最低賃金（営業所ごと。開いた代勤日に適用中のものと、そのあとに適用されるもの）
  minWageOffices: { office: string, rows: any[] }[] = [];
  // 最低賃金を取得できなかった
  minWageFailed = false;
  // 代勤者の営業所が決まらないとき（雇用指示が無いなど）に比べる営業所。高い方に寄せる
  defaultSalesOffice = '東京';
  // 契約の終了日（YYYY-MM-DD。契約詳細情報の一番遅い終了日。終わりが決まっていなければ null）。終了日の翌日以降の代勤は確認してから登録
  contractEndDate: string = null;
  // 契約の開始日（YYYY-MM-DD。契約詳細情報の一番早い開始日）。開始日より前の代勤も確認してから登録（契約の行の間の空きは見ない。ユーザー決定）
  contractStartDate: string = null;

  /** ローディング */
  loadingCompleteData:boolean = false;
  loadingCompleteSize:boolean = false;
  updateCompleteData:boolean = true;

  constructor(
    private router: Router,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<OperationDialogComponent>,
    private dialog: MatDialog) {
    super();
  }

  ngOnInit() {
    // スポット作業
    if (this.data['spot']) {
      this.spot = true
    }

    // 対象物件の住所、登録者を取得
    this.getData();
    this.getAreas();

    // 最低賃金マスタ（代勤者ごとに、その人の営業所の最低賃金と比べる）
    this.getMinWages();

    // 契約の期間（終了日の翌日以降には登録できない）
    this.getContractPeriod();

    // 稼働管理の対象日情報
    const dayData = this.data['days'][this.day]

    // 対象物件名（稼働管理の表では物件名1と2の間で改行しているが、ここでは1行で出す）
    this.siteName = String(this.data['nameSite'] || '').replace(/\r?\n/g, ' ');

    if (dayData) {
      // メモ
      this.note = dayData.note
      // あと何時間の確定代勤が要るか（計算は稼働管理の SQL。ここでは出すだけ）
      this.needHours = Number(dayData.needHours) || 0
      // 初出勤の日（判定は稼働管理の SQL）
      this.isFirstDay = !this.spot && !!dayData.isFirstDay
    }

    // 契約詳細の時間指定（その日の値。無ければ行の値＝表示期間のどこかで有なら「有」）
    this.specificTime = (dayData && dayData.specificTime) || this.data['specificTime'] || ''

    // 代勤時間の初期値設定
    this.setInitTime(dayData)

    // 清掃員取得
    this.applyFilter()

    // 物件概要書（警報）
    this.getOuLine()

    // 既に代勤登録されているデータ取得
    this.getWorkInsteadDataForSite()

    // ページ変更
    this.paginator.page.subscribe(() => {
      this.getPicklist(this.paginator.pageIndex, this.paginator.pageSize);
    });
  }

  /**
   * 対象物件情報を取得
   */
  getData() {
    this.http.get(API_BASE_URL + '/api/v1/sites/operationDialog?cdSite=' + this.data['cdSite']
      + '&cdContract=' + this.data['cdContract']
      + '&cdStaff=' + this.data['staffDailyCleaning']
      + '&day=' + this.day
      + '&sequenceNumber=' + this.data['sequenceNumber']
      + '&spot=' + this.spot,
      {headers: this.headers})
      .subscribe((res) => {
        if (res == null || (res as []).length == 0) {
          return
        }
        // 物件住所
        this.siteAddress = res[0].addressSite;

        // 月〜日の勤務表
        this.schedule = res[0];

        // 既に代勤登録されている
        if (res[0].createdDate) {
          this.operationCreatedDate = res[0].createdDate;
          this.operationCreatedUser = res[0].createdUser;
        }
      },
      error => {
        alert("認証に失敗しました");
        this.router.navigate(['/']);
      }
    );
  }

  /**
   * 契約の期間を取得（契約詳細情報の全部の行をまとめた開始日・終了日）
   * 代勤専門（000000000）は契約が無いので取らない。取れなかったときは止めない（契約の終了日のチェックだけできない）
   * API: contractDetail/period
   */
  getContractPeriod() {
    this.contractEndDate = null;
    this.contractStartDate = null;
    if (!this.data['cdSite'] || this.data['cdSite'] == '000000000') {
      return;
    }
    this.http.get(
      API_BASE_URL + '/api/v1/contractDetail/period?cdSite=' + encodeURIComponent(this.data['cdSite'])
        + '&cdContract=' + encodeURIComponent(this.data['cdContract'] || ''),
      {headers: this.headers}
    ).subscribe(res => {
      this.contractEndDate = (res && res['endDate']) ? String(res['endDate']).substring(0, 10) : null;
      this.contractStartDate = (res && res['startDate']) ? String(res['startDate']).substring(0, 10) : null;
    }, error => {
      if (error && (error.status == 401 || error.status == 403)) {
        alert("認証に失敗しました");
        this.router.navigate(['/']);
      }
    });
  }

  /**
   * 契約の終了日の翌日以降、または一番早い開始日より前の日が入っていれば確認する（契約が無い日に代勤・スポット作業を入れても誰も清掃しない）
   * 止めはしない（登録済みの代勤を消して入れ直す、などができなくなるため。ユーザー決定）。契約の行の間の空きは見ない（ユーザー決定）
   * @param days 代勤日（YYYY-MM-DD）
   * @returns やめるなら true
   */
  checkContractEnd(days: string[]): boolean {
    if (!days || !days.length) {
      return false;
    }
    const fmt = (d: string) => moment(d).format('YYYY/MM/DD');
    const over = this.contractEndDate ? days.filter(d => d > this.contractEndDate).sort() : [];
    const before = this.contractStartDate ? days.filter(d => d < this.contractStartDate).sort() : [];
    if (!over.length && !before.length) {
      return false;
    }
    let msg = '';
    if (over.length) {
      msg += '契約詳細情報で契約が終了しています。本当によろしいですか？\r\n\r\n'
        + '契約：' + (this.data['cdContract'] || '') + '　契約終了日：' + fmt(this.contractEndDate) + '\r\n'
        + '終了日より後の日：' + over.map(fmt).join('、') + '\r\n';
    }
    if (before.length) {
      msg += (msg ? '\r\n' : '') + '契約詳細情報で契約がまだ始まっていません。本当によろしいですか？\r\n\r\n'
        + '契約：' + (this.data['cdContract'] || '') + '　契約開始日：' + fmt(this.contractStartDate) + '\r\n'
        + '開始日より前の日：' + before.map(fmt).join('、') + '\r\n';
    }
    return !window.confirm(msg);
  }

  /**
   * エリアドロップダウン生成
   */
  getAreas() {
    const area = getAreaSession()

    if (area && area.length) {
      this.areas = area
    } else {
      this.http.get(
        API_BASE_URL + "/api/v1/area", {headers: this.headers}
      ).subscribe(res => {
        this.areas = res as any[];

        // セッション保存
        saveAreaSession(this.areas)
      }, error => {
        alert("認証に失敗しました");
        this.router.navigate(['/']);
      });
    }
  }

  /**
   * 最低賃金マスタを全部取得（営業所ごと。代勤者の営業所の行と比べる）
   * 最低賃金は RP で変更されるので、ダイアログを開くたびに取得する
   * API: minWage/all
   */
  getMinWages() {
    this.http.get(
      API_BASE_URL + "/api/v1/minWage/all", {headers: this.headers}
    ).subscribe(res => {
      this.minWageList = res as any[];
      this.minWageFailed = false;
      this.setMinWageRows();
    }, error => {
      if (error && (error.status == 401 || error.status == 403)) {
        alert("認証に失敗しました");
        this.router.navigate(['/']);
        return;
      }
      // 取得できなかったときは、最低賃金のチェックができないことを画面に出す
      this.minWageList = [];
      this.minWageFailed = true;
      this.setMinWageRows();
    });
  }

  /**
   * 画面に出す最低賃金（営業所ごとに、開いた代勤日に適用中のものと、そのあとに適用されるもの）
   * 代勤者の営業所は東京／千葉のどちらかなので、マスタにそれ以外の区分（埼玉。RP の賃金一括変更だけで使う）があっても出さない
   */
  setMinWageRows() {
    const offices = [];
    for (let i = 0; i < this.minWageList.length; i++) {
      const m = this.minWageList[i];
      if (m.endDay && m.endDay < this.day) continue;
      if (m.salesOffice != '東京' && m.salesOffice != '千葉') continue;
      let o = offices.find(x => x.office == m.salesOffice);
      if (!o) {
        o = { office: m.salesOffice, rows: [] };
        offices.push(o);
      }
      o.rows.push(m);
    }
    this.minWageOffices = offices;
  }

  /**
   * 代勤者の最低賃金を比べる営業所（東京／千葉）を取得。東京と千葉の両方に所属していれば東京
   * API: operations/staffSalesOffice
   * @param cdStaff 代勤者の清掃員コード
   * @returns 営業所。取れなければ null
   */
  getStaffSalesOffice(cdStaff: string): Promise<string> {
    return new Promise(resolve => {
      this.http.get(
        API_BASE_URL + "/api/v1/operations/staffSalesOffice?day=" + this.day + "&cdStaff=" + encodeURIComponent(cdStaff),
        {headers: this.headers}
      ).subscribe(res => {
        resolve(res && res['salesOffice'] ? res['salesOffice'] : null);
      }, error => {
        resolve(null);
      });
    });
  }

  /**
   * その日・その営業所に適用される最低賃金
   * @param day 日付（YYYY-MM-DD）
   * @param office 営業所（東京／千葉）
   * @returns 最低賃金の行。無ければ null
   */
  minWageAt(day: string, office: string) {
    const res = this.minWageList.filter(m => m.salesOffice == office && m.startDay <= day && (!m.endDay || m.endDay >= day));
    return res.length ? res[0] : null;
  }

  /**
   * 代勤者ごとに、その人の営業所の最低賃金より賃金が低くないか確認（代勤日ごとに、その日に適用される最低賃金）
   * 複数日の登録では同じ賃金を全部の日に使うので、1日でも下回る日があれば止める
   * 営業所が決まらない代勤者は東京（高い方）と比べる
   * @param days 代勤日（YYYY-MM-DD）
   * @returns 下回っていれば true
   */
  checkMinWage(days: string[]) {
    for (let i = 0; i < this.workInsteads.length; i++) {
      const w = this.workInsteads[i];
      const office = w.salesOffice || this.defaultSalesOffice;

      // この代勤者の営業所で、最低賃金が一番高くなる日
      let target = null;
      let targetDay = '';
      for (let j = 0; j < days.length; j++) {
        const m = this.minWageAt(days[j], office);
        if (m && (!target || m.minWage > target.minWage)) {
          target = m;
          targetDay = days[j];
        }
      }
      if (!target) continue;

      if (target.minWage > Number(w.basicWage)) {
        const name = w.workInstead ? w.workInstead + 'さんの' : '';
        const min = Number(target.minWage).toLocaleString();
        alert(`最低賃金より低くなっています。\r\n${name}賃金を ${min}円以上にしてください。\r\n\r\n`
          + `代勤日 ${moment(targetDay).format('YYYY/MM/DD')} の ${office} の最低賃金：${min}円`
          + `（${moment(target.startDay).format('YYYY/MM/DD')} から適用）`);
        w.basicWage = null;
        return true;
      }
    }
    return false;
  }

  /**
   * 勤務表の1コマの表示（休み登録ダイアログと同じ）。「10:00~15:00 (5)」の実働の前で改行、勤務なしは「-」
   * @param val get_attendance_time_hour_name の文字列
   */
  formatWorkTime(val) {
    if (val) {
      let res = String(val).replace('：', '')
      res = res.replace(/\(/g, '\r\n(')
      return res
    } else {
      return '-'
    }
  }

  /**
   * 代勤時間の初期値設定
   * @param dayData 対象日のデータ
   */
  setInitTime(dayData) {
    this.startTime = '0:00';
    this.endTime = '0:00';

    if (dayData && dayData.workingTime) {
      // 作業開始・作業終了・契約開始・契約終了の日は「13:00 - 16:00\n作業終了」のように2行目に印が付くので、1行目だけを使う
      let time = String(dayData.workingTime).split('\n')[0].trim()

      // 祝日で短縮の日は「祝日3h出勤」と出ていて時間帯が無いので、祝日で整える前の時間帯（元の時間）を使う
      if (time.startsWith('祝日') && dayData.timeText) {
        time = String(dayData.timeText).trim()
      }

      // 時間あり
      if (time && time !== '-' && time.includes('-')) {
        const timeSplit = time.split('-');
        this.startTime = timeSplit[0].trim();
        this.endTime = timeSplit[1].trim();
      }
    }
  }

  /**
   * 清掃員リスト検索（ページ数初期化）
   */
  applyFilter() {
    this.paginator.pageIndex = 0;
    this.getPicklist(this.paginator.pageIndex, this.paginator.pageSize);
  }

  /**
   * エリア検索
   * @param opened 選択肢OPEN
   */
  onAreaSelectOpened(opened: boolean) {
    // 閉じた瞬間だけ検索
    if (!opened) {
      this.applyFilter()
    }
  }

  /**
   * 代勤候補者のリストを取得
   * @param index ページ数
   * @param size 1ページに表示する件数
   */
  getPicklist(index: number, size: number) {
    this.loadingCompleteData = false;

    if(size == undefined)
      size = 50;

    this.http.get(
      API_BASE_URL + '/api/v1/operations/picklist?s=0&e=8000&index=' + index
        + "&size=" + size
        + "&filterName=" + encodeURIComponent(this.filterName)
        + "&filterNameKana=" + encodeURIComponent(this.filterNameKana)
        + "&siteName=" + encodeURIComponent(this.filterSiteName)
        + "&cdSite=" + this.data['cdSite']
        + "&areas=" + this.areaIds
        + "&hasWorked=" + this.hasWorked
        + "&hasExperience=" + this.hasExperience
        + "&freeStaff=" + this.freeStaff
        + "&position=" + this.position
        + "&canInstead=" + this.canInstead
        + "&day=" + this.day,
      {headers: this.headers}
    )
    .subscribe(res => {
      this.dataSource = new MatTableDataSource(res as Staff[]);

      // ページネーターに表示する全サイズを取得
      let data = res as any[];
      if (data.length > 0) {
        this.dataSourceLength = data[0].totalSize;
        if (data[0].distance == -1) {
          this.noPositionMsg = '当物件の位置情報が取得できませんでした。'
        }
      } else {
        this.dataSourceLength = 0;
      }
      this.loadingCompleteData = true;
    },
    error => {
      alert("エラーが発生しました");
      this.router.navigate(['/']);
    });
  }

  /**
   * 物件概要書の情報を取得
   * 今は警報の有無のみ
   */
  getOuLine() {
    this.isAlarm = ''
    this.http.get(
      API_BASE_URL + "/api/v1/siteInfo/outline?cdSite=" + this.data['cdSite'], {headers: this.headers}
    ).subscribe(res => {
      const outline = res;
      if (outline && outline['isAlarm']) {
        this.isAlarm = outline['isAlarm']
      }
    }, error => {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
    });
  }

  /**
   * 当日に当物件で代勤登録されているデータを取得
   */
  getWorkInsteadDataForSite() {
    // 代勤登録されているデータを取得
    this.http.get(API_BASE_URL + '/api/v1/operations/workInsteadData?&staffDailyCleaning=' + this.data['staffDailyCleaning']
      + '&cdSite=' + this.data['cdSite']
      + '&sequenceNumber=' + this.data['sequenceNumber']
      + '&day=' + this.day,
      {headers: this.headers})
      .subscribe(async (res) => {
        const data = res as any[]

        for (let i = 0; i < data.length; i++) {
          const row = data[i]
          // スポットかつスポット作業か、代勤かつスポット作業以外
          if ((this.spot && row.status == 'スポット作業') || (!this.spot && row.status != 'スポット作業')) {
            await this.convertToWorkInsteadData(row)

            // すでに保存済みで勤務確定、実働時間あり、引継ぎではない場合
            if (this.routStatus.includes(row.status) && row.workingHours && !row.takeOver) {
              this.existingWorkingHours += Number(row.workingHours)
            }
          }
        }
      },
      error => {
        alert("認証に失敗しました");
        this.router.navigate(['/']);
      }
    );
  }

  /**
   * 代勤が既に登録されている場合、代勤情報を表示する
   */
  async convertToWorkInsteadData(d: any) {
    // 代勤データ
    const data = { ...d,  noMapMsg: '' }

    // 代勤データをセット
    await this.setWorkInstead(data, false)
  }

  /**
   * 代勤候補者の名前クリックイベント
   * @param row
   */
  async addWorkInstead(row: any) {
    // 7連勤確認
    this.http.get(
      API_BASE_URL + "/api/v1/operations/isWorking7Days?cdStaff=" + row.staffDailyCleaning
        + "&day=" + this.day
        , {headers: this.headers}
    ).subscribe(res => {
      const check = res as boolean
      if (check) {
        if (this.spot) {
          alert('【警告】 登録できますが、７連勤以上になります。');
        } else {
          alert('７連勤となる為、追加できません。')
          return
        }
      }

      // 選択されたスタッフのデータを取得
      this.http.get(
        API_BASE_URL + "/api/v1/operations/selectedStaff?day=" + this.day
        + "&cdStaff=" + row.staffDailyCleaning
        + "&cdSite=" + this.data['cdSite']
        , {headers: this.headers}
      ).subscribe(async res => {
        // 1行目を見る（バックは賃金が無い人でも賃金なしの行を1つ返す。念のため空でも止まらないようにする）
        const list = res as any[]
        const selectedStaff = (list && list.length) ? list : [{}]

        // 出禁になっている場合
        if (selectedStaff[0].notInstead) {
          alert(`${selectedStaff[0].notInstead}さんは出入り禁止になっているため、登録できません。`)
          return
        }

        const data = {
          id: null,
          workInsteadStaffDailyCleaning: row['staffDailyCleaning'],
          workInstead:  row.nameStaff,
          numberPhone: row.numberPhoneStaff,
          numberMobilePhone: row.numberMobilePhoneStaff,
          workInsteadAddress: row.address1,
          basicWage: selectedStaff[0].basicWage,
          workInsteadKubunWage: selectedStaff[0].kubunWage,
          // 最低賃金を比べる営業所（東京／千葉）
          salesOffice: selectedStaff[0].salesOffice,

          // 以下初期値
          status: (this.spot ? 'スポット作業' : this.statusChoices[0]['value']),
          startTime: this.startTime,
          endTime: this.endTime,
          transportationExpenses: '0',
          commuteTime: '',
          workingHours: this.getWorkingHours(),
          // 初出勤の日は本人以外の代勤者を引継・指導で登録する運用なので、最初から ON（本人（本人選択）は引継ぎではない。外して普通の代勤にしてもよい）
          takeOver: this.isFirstDay && String(row.staffDailyCleaning) != String(this.data['staffDailyCleaning']),
          noTransportCost: false,
          noMapMsg: ''
        }

        // 代勤データをセット
        await this.setWorkInstead(data, true)
      }, error => {
        alert("認証に失敗しました");
        this.router.navigate(['/']);
      })
    },error => {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
    });
  }

  /**
   * 本人選択ボタン：この行の通常清掃員を代勤者として追加
   * 左の表から選んだときと同じ流れ（7連勤・出入り禁止・賃金と営業所の取得・交通費）。通常清掃員の名前・電話・住所は sites/operationDialog の値
   */
  async addSelf() {
    if (!this.schedule || this.data['staffDailyCleaning'] == '-1') return

    await this.addWorkInstead({
      staffDailyCleaning: this.data['staffDailyCleaning'],
      nameStaff: this.schedule.name || this.data['nameStaff'],
      numberPhoneStaff: this.schedule.numberPhone,
      numberMobilePhoneStaff: this.schedule.numberMobilePhone,
      address1: this.schedule.address
    })
  }

  /**
   * 実働時間 取得
   */
  getWorkingHours() {
    // 稼働管理の対象日情報
    const dayData = this.data['days'][this.day]

    if (dayData) {
      return Number(dayData['hours'])
    }
    return 0
  }

  /**
   * 代勤データをセット
   * @param data 対象データ
   * @param isAdd 交通費を取得するか否か（清掃員を追加した際はTRUE）
   */
  async setWorkInstead(data, isAdd: Boolean) {

    data.sequenceNumber = this.data['sequenceNumber']
    data.cdSite = this.data['cdSite']
    data.staffDailyCleaning = this.data['staffDailyCleaning']
    data.cdContract = this.data['cdContract']
    data.siteAddress = this.siteAddress
    data.note = this.note
    data.startHour = ''
    data.startMinutes = ''
    data.endHour = ''
    data.endMinutes = ''
    data.commuteHour = ''
    data.commuteMinutes = ''

    // 時間を時と分に分割
    this.setTime(data)

    this.workInsteads.push(data);

    // 最低賃金を比べる営業所（登録済みの代勤を開き直したときは持っていないので引く）
    if (!data.salesOffice && data['workInsteadStaffDailyCleaning']) {
      data.salesOffice = await this.getStaffSalesOffice(data['workInsteadStaffDailyCleaning'])
    }

    // 出発地点をセットするため、代勤者のその日の物件データを取得
    await this.getWorkInsteadData(data['workInsteadStaffDailyCleaning'])

    // GoogleMap用の出発地をセット
    const today = this.setStartEndPoint(data['workInsteadDataByDay'], data['startTime'], data['endTime'], data['workInsteadAddress'])

    // 出発地点、目的地がともにあれば、GoogleMapを表示
    const routeMapValue = this.getMap(today, this.siteAddress)

    data['routeMap'] = routeMapValue.start
    data['routeMap2'] = routeMapValue.end
    data['notEnd'] = routeMapValue.notEnd
    data['today'] = today
    data['startName'] = today.startName
    data['endName'] = today.endName
    data['startPoint'] = today.startPoint
    data['endPoint'] = today.endPoint

    // console.log('ins完成！！！')
    // console.log(data)

    if (isAdd) {
      // 交通費を取得
      const trans = await this.getTransportation(data['workInsteadStaffDailyCleaning'], today, this.day, false)
      data['transportationExpenses'] = trans.price
      data['noMapMsg'] = trans.noMapMsg
    }
  }


  /**
   * 時間の設定
   * @param workInstead 設定値
   */
  setTime(workInstead){
    workInstead.startHour = 0;
    workInstead.startMinutes = '00';
    workInstead.endHour = 0;
    workInstead.endMinutes = '00';
    workInstead.commuteHour = 0;
    workInstead.commuteMinutes = 0;

    if(!workInstead.startTime) workInstead.startTime = '0:00';
    if(!workInstead.endTime) workInstead.endTime = '0:00';
    // 通勤時間は1分単位なので「0:0」とする
    if(!workInstead.commuteTime) workInstead.commuteTime = '0:0';

    const startTimeArr = workInstead.startTime.split(':');
    if (startTimeArr && startTimeArr.length) {
      if (startTimeArr[0]) {
        workInstead.startHour = Number(startTimeArr[0].trim());
      }
      if (startTimeArr[1]) {
        workInstead.startMinutes = startTimeArr[1].trim();
      }
    }

    const endTimeArr = workInstead.endTime.split(':');
    if (endTimeArr && endTimeArr.length) {
      if (endTimeArr[0]) {
        workInstead.endHour = Number(endTimeArr[0]);
      }
      if (endTimeArr[1]) {
        workInstead.endMinutes = endTimeArr[1].trim();
      }
    }

    const cTimeArr = workInstead.commuteTime.split(':');
    if (cTimeArr && cTimeArr.length) {
      if (cTimeArr[0]) {
        workInstead.commuteHour = Number(cTimeArr[0].trim());
      }
      if (cTimeArr[1]) {
        workInstead.commuteMinutes = Number(cTimeArr[1].trim());
      }
    }
  }

  /**
   * 出発地点をセットするため、代勤者のその日の物件データを取得（確定しているデータ：給料発生のデータのみ）
   * ('●：代勤OK', '休み取り消し', 'スポット作業')の代勤データ+通常物件データ（休み登録なしの場合のみ）
   * @param staffCd 清掃員コード（代勤者）
   */
  async getWorkInsteadData(staffCd: string) {
    let savedData = [];

    await this.http.get(
      API_BASE_URL + "/api/v1/operations/workInsteadDataByDay?staffCd=" + staffCd
      + "&day=" + this.day
      , {headers: this.headers})
      .toPromise().then((res: any) => {
        savedData = res;
        console.log(savedData)
      })
      .catch(() => {
        alert("認証に失敗しました");
        this.router.navigate(['/']);
      });

    // 画面表示されている代勤で対象と同じ人を更新
    this.workInsteads.forEach((row, i) => {
      // 同一人物
      if (row.workInsteadStaffDailyCleaning == staffCd) {

        // 現在代勤画面に表示している分（未保存）も取得（勤務確定のもののみ）元配列に影響しないようにコピー
        const wis = this.workInsteads.filter((w, i2) => {
          // 該当ステータス＆同じ人物＆その代勤以外＆未保存の分のみ
          return this.routStatus.includes(w.status) && staffCd == w.workInsteadStaffDailyCleaning && i != i2
          // コピー
        }).map(item => ({ ...item, setNow: true, nameSite: this.siteName }))

        // 削除したものがある場合
        if (this.remove && this.remove.length) {
          const removeId = this.remove.map((re) => {
            return re.id
          })
          // 削除したもの以外を取得
          savedData = savedData.filter((s) => {
            return !removeId.includes(s.id)
          })
        }
        const wisID = []
        wis.forEach((row) => {
          if (row.id) {
            wisID.push(row.id)
          }
        })

        // 保存済みの中から、その代勤自身以外を取得
        const sd = savedData.filter((s) => {
          return s.id != row.id && !wisID.includes(s.id)
        })

        let all = [];
        // 終了時間が速い順に並べ替え
        all = wis.concat(sd)
        all.sort((a, b) => {
          const toNum = t => Number(t.replace(':', ''))
          return toNum(a.endTime) - toNum(b.endTime)
        })

        row.workInsteadDataByDay = all
      }
    });

    // 新規で追加した場合
    // if (isAdd) {
    //   // 現在代勤画面に表示している分（未保存）も取得（勤務確定のもののみ）元配列に影響しないようにコピー
    //   const wis = this.workInsteads.filter((w) => {
    //     // 該当ステータス＆同じ人物＆その代勤以外＆未保存の分のみ
    //     return this.routStatus.includes(w.status) && staffCd == w.workInsteadStaffDailyCleaning && !w.id
    //     // コピー
    //   }).map(item => ({ ...item, setNow: true, nameSite: this.siteName }))

    //   // 終了時間が速い順に並べ替え
    //   let all = wis.concat(savedData)
    //   all.sort((a, b) => {
    //     const toNum = t => Number(t.replace(':', ''))
    //     return toNum(a.endTime) - toNum(b.endTime)
    //   })
    //   return all
    // }
  }

  /**
   * 出発地点をセット
   * @param startTime 予定開始時間（画面表示している開始時間）
   * @param ad1 代勤者の住所1
   * @param operationId 代勤ID
   * @returns
   */
  setStartEndPoint(workInsteadDataByDay, startTime: any, endTime: any, ad1: string){
    let data = {
      startId: null,
      startName: null,
      startPoint: null,
      startStatus: null,
      endId: null,
      endName: null,
      endPoint: null,
      endStatus: null
    }

    if (workInsteadDataByDay) {

      // 時間比較するために「：」を削除し数値に変換
      const startT = Number(startTime.replace(':',''));

      // 昇順になっているので、後ろから検索
      for (let i = workInsteadDataByDay.length-1; i > -1; i--) {
        const row = workInsteadDataByDay[i]

        // 入力された開始時間より早い終了時間があれば、startPointに前物件住所をセット（すでに編集対象は除いている）
        if (Number(row.endTime.replace(':', '')) <= startT && row.startTime != startTime && row.endTime != endTime) {
          // データの最後から見ているため、最初にヒットしたものでOK

          // 未保存で画面に今追加したものは架空のID
          if (row.setNow) {
            data.startId = -100
          } else {
            data.startId = row.id; // -10は担当物件
          }

          data.startName = row.nameSite;
          data.startPoint = row.siteAddress;
          data.startStatus = row.status;
          break;
        }
      }
    }
    // 前物件がなければ、出発地点に代勤者の住所をセット
    if (!data.startId) {
      data.startName= '自宅';
      data.startPoint = ad1;
    }

    // 時間比較するために「：」を削除し数値に変換
    const endT = Number(endTime.replace(':',''));

    // 直後の仕事を検索
    for (let i = 0; i < workInsteadDataByDay.length; i++) {
        const row = workInsteadDataByDay[i]

      // 入力された終了時間より遅い開始時間があれば、endPointに直後の物件住所をセット（すでに編集対象は省いている）
      if (Number(row.startTime.replace(':','')) >= endT && row.startTime != startTime && row.endTime != endTime) {
        // 終了時間は降順で取得しているため、最初にヒットしたものでOK

        // 未保存で画面に今追加したものは架空のID
        if (row.setNow) {
          data.endId = -100
        } else {
          data.endId = row.id; // -10は担当物件
        }

        data.endName = row.nameSite;
        data.endPoint = row.siteAddress;
        data.endStatus = row.status;
        break;
      }
    }

    // 直後の仕事がない場合
    if (!data.endId) {
      // 次の目的地は自宅
      data.endName= '自宅';
      data.endPoint = ad1;
    }
    return data;
  }

  /**
   * 時間変更イベント_開始時間
   * @param workInstead 代勤レコード
   */
  selectionChangeStartTime(workInstead) {
    this.saveDisabled = false;
    workInstead.startTime = workInstead.startHour + ':' + workInstead.startMinutes;
    this.changeTime(workInstead)
  }

  /**
   * 時間変更イベント_終了時間
   * @param workInstead 代勤レコード
   */
  selectionChangeEndTime(workInstead) {
    this.saveDisabled = false;
    workInstead.endTime = workInstead.endHour + ':' + workInstead.endMinutes;
    this.changeTime(workInstead)
  }

  /**
   * 時間変更時の処理
   */
  changeTime(workInstead) {
    // 開始時間、終了時間が逆になってる場合は、保存ボタンを非活性
    this.setSaveDisabled();

    // 実働時間設定
    this.setWorkingHours(workInstead);

    if (Number(workInstead.workingHours) > 0) {
      this.formedDataByDay(workInstead, null)
      // 交通費、MAPのURL取得
      workInstead = this.getTransAndMap(workInstead, false, false);
    }
  }

  /**
   * 「変更を保存」ボタンの活性、非活性を設定　(開始、終了時間を確認)
   */
  setSaveDisabled() {
    if (this.workInsteads) {
      for (let i = 0; i < this.workInsteads.length; i++) {
        if (Number(this.workInsteads[i].startTime.replace(':','')) > Number(this.workInsteads[i].endTime.replace(':',''))) {
          this.saveDisabled = true;
        }
      }
    }
  }

  /**
   * 時間変更イベント_通勤時間
   * @param workInstead 代勤レコード
   */
  selectionChangeCommutTime(workInstead) {
    workInstead.commuteTime = workInstead.commuteHour + ':' + workInstead.commuteMinutes;
  }

  /**
   * 金額keydownイベント
   * @param event イベント情報
   * @returns
   */
   onkeydownMoney(event: any) { // without type info
    //制御のキーは有効( Left / Up / Right / Down Arrow, Backspace, Delete keys, Tab, Home, End)
    let keyCode = event.keyCode;
    if(keyCode == 37 || keyCode == 38 || keyCode == 39 || keyCode == 40 || keyCode == 8 || keyCode == 46 || keyCode == 9 || keyCode == 36 || keyCode == 35) {
      return true;
    }

    //数字キーは有効
    let key = event.key;
    let result = key.match(/[^0-9]/);
    if (result) {
      return false;
    }
    return true;
  }

  /**
   * 削除ボタンイベント
   * @param target 削除するデータ
   * @param i
   */
  async removeWorkInstead(target: any, i: number) {
    if(window.confirm(target.workInstead + "さんの代勤登録を削除してもよろしいでしょうか？")){
      this.workInsteads.splice(i, 1);
      if (target.id) {
        target.day = this.day
        this.remove.push(target);
      }
      // 同じ清掃のルート変更
      this.formedDataByDay(target, target.id)
      // 対象のステータスKのみ再取得
      if (this.routStatus.includes(target.status)) {
        // 同じ清掃員の交通費再取得
        for (let i = 0; i < this.workInsteads.length; i++) {
          const row = this.workInsteads[i];
          if (target.workInsteadStaffDailyCleaning == row.workInsteadStaffDailyCleaning) {
            // 交通費、MAPのURL取得
            await this.getTransAndMap(row, true, false);
          }
        }
      }
    }
  }

  /**
   * 賃金変更イベント
   */
  changeWage() {
    // 賃金の金額をチェック
    this.checkWage();
  }

  /**
   * 交通費変更イベント
   * @param workInstead 代勤データ
   */
  changeTrans(workInstead) {
    // 交通費に金額が入力されたら「交通費なし」チェックを外す
    if (workInstead.transportationExpenses != null && workInstead.transportationExpenses != 0 && workInstead.transportationExpenses != '') {
      workInstead.noTransportCost = false;
    }
  }

  /**
   * 交通費なしチェックイベント
   * @param workInstead 代勤データ
   */
  changeNoTrans(workInstead) {
    if (workInstead.noTransportCost) {
      workInstead.transportationExpenses = 0;
    }
  }

  /**
   * 代勤者候補名の色をセット_緯度経度が取得不可の清掃員名は赤色
   */
  setColor(staffLatitude) {
    if (staffLatitude == -1) {
      return 'color-red';
    } else {
      return 'color-blue'
    }
  }

  /**
   * 交通費を取得
   * @param staffCd 清掃員コード
   * @param today 代勤者のその日の前後のスケジュール
   */
  async getTransportation(staffCd, today, day, again) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "X-LoginAccessKey": localStorage.getItem("accessKey")
      })
    };

    let noMapMsg = '';

    let price = '';

    if (today.newAddress || this.siteAddress) {

      this.loadingCompleteData = false;
      await this.http.post(
        API_BASE_URL + "/api/v1/operations/getTrans?staffCd=" + staffCd
          + "&cdSite=" + this.data['cdSite']
          + "&siteAddress=" + (today.newAddress || this.siteAddress)
          + "&day=" + day
          + "&again=" + again
          , today
          , httpOptions)
          .toPromise().then((res: any) => {

            // 取得不可の場合
            if (!res || res.fare == -1) {
              noMapMsg = '交通費を取得できませんでした';
              price = '';
            } else {
              price = res.fare

              if (res.charge == 1) {
                noMapMsg = '担当物件のため雇用指示の交通費を表示しています';
              }
            }
            this.loadingCompleteData = true;
          })
          .catch(() => {
            alert("認証に失敗しました");
            this.router.navigate(['/']);
            this.loadingCompleteData = true;
          });
    }
    return { price, noMapMsg };
  }

  /**
   * 複数日選択ボタン　イベント
   */
  public selectDays() {
    this.multipleDay = true;
  }

  /**
   * 戻るボタン　イベント
   */
  public back() {
    this.multipleDay = false;
  }

  /**
   * 開始日、終了日のクラス名設定
   */
  classForTime() {
    // 連日
    if (this.displaySpecifyDate == 'consecutive') {
      return 'time-consecutive';
    // 曜日指定
    } else if (this.displaySpecifyDate == 'weekday') {
      return 'time-weekday'
    }
  }

  /**
   * 開始日 変更時の処理
   * @param event 開始日
   */
  changeStart(event) {
    this.start = event.value;
  }

  /**
   * 終了日 変更時の処理
   * @param event 終了日
   */
  changeEnd(event) {
    this.end = event.value;
  }

  /**
   * 「複数日指定」のカレンダーマークをクリックした際にする処理
   * @param calendar
   */
  openCalendar(calendar: any) {
    // カレンダーを更新
    calendar.updateTodaysDate();
  }

  /**
   * 「複数日指定」選択した日を表示する
   * @param event 選択した日
   * @param calendar カレンダー
   */
  select(event: any, calendar: any) {
    let date = moment(event).format('YYYY-MM-DD');
    let dateFormat = moment(date).format('YYYY/MM/DD');
    const index = this.daysSelected.findIndex(x => x == date);
    if (index < 0) {
      this.daysSelected.push(date);
      this.daysArray.push(dateFormat);
      this.days = this.daysArray.join(", ");
    } else {
      // すでに選択済みの日をクリックした場合、配列から削除
      this.daysSelected.splice(index, 1);
      this.daysArray.splice(index, 1);
      this.days = this.daysArray.join(", ");
    }
    // 選択した日に色を付けるため、クリックするたびにカレンダーを更新
    calendar.updateTodaysDate();
  }

  /**
   * 「複数日指定」選択した日に色を付ける
   * @param event 選択した日
   * @returns
   */
  isSelected = (event: any) => {
    const date = moment(event).format('YYYY-MM-DD');
    return this.daysSelected.find(x => x == date) ? 'selected' : null;
  }

  clear() {
    this.initialized();
    this.displaySpecifyDate = 'consecutive';
  }

  /**
   * 画面表示
   */
  initialized() {
    // 日付けを初期化
    this.start = new Date(this.data['day']);
    this.end = new Date(this.data['day']);
    // 複数日選択
    this.daysSelected = [];
    // 複数日選択（表示用）
    this.days = '';
    this.daysArray = [];
  }

  /**
   * 実働時間設定
   * 開始・終了時間より計算
   * @param wInstead 代勤レコード
   */
  setWorkingHours(wInstead) {
    let sTime = moment(this.day + ' ' + wInstead.startTime + ':00');
    let eTime = moment(this.day + ' ' + wInstead.endTime + ':00');
    let diff = eTime.diff(sTime, 'minute');
    diff = diff / 60;

    if (diff <= 0) {
      wInstead.workingHours = '0.00';
    } else if (diff >= 6 ) {
      // ６時間以上の勤務で１時間休憩
      wInstead.workingHours = diff - 1
    } else {
      wInstead.workingHours = diff
    }
  }

  /**
   * tbl_operation_note用のデータを生成
   * @param days
   */
  setOperationNote (days) {
    this.operationNote = [];
    for (let i = 0; i < days.length; i++) {
      const row = {
        operationNoteId: {
          sequenceNumber: this.data['sequenceNumber'],
          staffDailyCleaning: this.data['staffDailyCleaning'],
          cdSite: this.data['cdSite'],
          day: days[i],
        },
        cdContract: this.data['cdContract'],
        note: this.note
      }
      this.operationNote.push(row)
    }
  }

  /**
   * googleMapのURLを生成
   * @param today 本日の代勤者の予定
   * @param siteAddress 代勤物件の住所
   * @returns
   */
  getMap(today, siteAddress) {

    // 行き（行は必ず）
    let start = 'https://www.google.com/maps/dir/?api=1&origin=' + this.replaceSpace(today.startPoint) + '&destination=' + this.replaceSpace(siteAddress) + '&travelmode=transit&hl=ja&gl=jp'

    // 帰り
    let end = 'https://www.google.com/maps/dir/?api=1&origin=' + this.replaceSpace(siteAddress) + '&destination=' + this.replaceSpace(today.endPoint) + '&travelmode=transit&hl=ja&gl=jp'

    // 帰りは次に物件が入っていない場合にかぎる
    let notEnd = false
    if (today.endId) {
      notEnd = true
    }

    return { start, end, notEnd }
  }

  /**
   * スペースはハイフンに置換
   * @param value 対象値
   * @returns
   */
  replaceSpace(value) {
    let result = value;
    if (result) {
      result = result.replace(/ /g, '-');
      result = result.replace(/　/g, '-');
    }
    return result;
  }

  /**
   * 代勤者の当日の代勤データ（対象ステータスのみ）を取得
   */
  async getInsteadOK(list) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "X-LoginAccessKey": localStorage.getItem("accessKey")
      })
    };

    let data

    try {
      data = await this.http
        .post(API_BASE_URL + '/api/v1/operations/getInsteadOK', list, httpOptions)
        .toPromise();

    } catch (error) {
      alert('認証に失敗しました');
      this.router.navigate(['/']);
    }
    return data;
  }

  /**
   * ステータス変更イベント
   * @param target 該当代勤データ
   */
  async selectStatus(target) {
    this.formedDataByDay(target, null)
    // 対象のステータスのみ再取得
    if (this.routStatus.includes(target.status)) {
      // 同じ清掃員の交通費再取得
      for (let i = 0; i < this.workInsteads.length; i++) {
        const row = this.workInsteads[i];
        if (target.workInsteadStaffDailyCleaning == row.workInsteadStaffDailyCleaning) {
          // 交通費、MAPのURL取得
          await this.getTransAndMap(row, true, false);
        }
      }
    }
  }

  /**
   * 当日の代勤者勤務情報を並べ替え
   * @param target
   * @param removeId 削除した保存済みのID
   */
  formedDataByDay(target, removeId) {
    // 代勤清掃員
    const staffCd = target.workInsteadStaffDailyCleaning

    // 画面表示されている代勤で対象と同じ人を更新
    this.workInsteads.forEach((row, i) => {
      // 同一人物
      if (row.workInsteadStaffDailyCleaning == staffCd) {

        // 現在代勤画面に表示している分（未保存）も取得（勤務確定のもののみ）元配列に影響しないようにコピー
        const wis = this.workInsteads.filter((w, i2) => {
          // 該当ステータス＆同じ人物＆その代勤以外＆未保存の分のみ
          return this.routStatus.includes(w.status) && staffCd == w.workInsteadStaffDailyCleaning && i != i2
          // コピー
        }).map(item => ({ ...item, setNow: true, nameSite: this.siteName }))

        // 当日の確定勤務
        let savedData = row.workInsteadDataByDay || []
        if (removeId) {
          savedData = savedData.filter((s) => {
            return s.id != removeId
          })
        }

        const wisID = []
        wis.forEach((row) => {
          if (row.id) {
            wisID.push(row.id)
          }
        })

        // 当日の確定勤務の中から保存済みを取得
        const sd = savedData.filter((s) => {
          return s.id && !wisID.includes(s.id)
        })

        // 終了時間が速い順に並べ替え
        let all = wis.concat(sd)
        all.sort((a, b) => {
          const toNum = t => Number(t.replace(':', ''))
          return toNum(a.endTime) - toNum(b.endTime)
        })
        row.workInsteadDataByDay = all
      }
    });
  }

  /**
   * 交通費、MAPのURL取得
   * @param workInstead
   * @param required 取得必須
   * @returns
   */
  async getTransAndMap(workInstead, required, again) {
    // 代勤者のその日のスケジュール
    let today = this.setStartEndPoint(workInstead.workInsteadDataByDay, workInstead.startTime, workInstead.endTime, workInstead.workInsteadAddress);

    // googleMapのURL生成
    let routeMapValue = this.getMap(today, this.siteAddress);
    workInstead.routeMap = routeMapValue.start;
    workInstead.routeMap2 = routeMapValue.end;
    workInstead.notEnd = routeMapValue.notEnd;

    // データ取得必須、もしくは当日のデータの並びが変わったら交通費を再取得
    if (required || !workInstead.today || !_.isEqual(today,  workInstead.today)) {
      workInstead['today'] = today;
      workInstead['startName'] = today.startName
      workInstead['endName'] = today.endName
      workInstead['startPoint'] = today.startPoint
      workInstead['endPoint'] = today.endPoint

      // 交通費を取得
      let trans = await this.getTransportation(workInstead.workInsteadStaffDailyCleaning, today, this.day, again);
      // 代勤交通費をセット
      workInstead.transportationExpenses = trans.price;
      // 交通費取得不可のコメント
      workInstead.noMapMsg = trans.noMapMsg;
    }
    return workInstead;
  }

  /**
   * 交通費再取得ボタン
   */
  async getTransAgainBtn(workInstead) {
    this.formedDataByDay(workInstead, null)
    await this.getTransAndMap(workInstead, true, true)
  }

  /**
   * メールダイアログ表示
   */
  openMailDialog(data: any[]): Promise<any> {
    let target = []
    let mobile = []
    let staff = []
    for (let i = 0; i < data.length; i++) {
      const d = data[i]
      // 代勤OKの場合
      if (d.status == '●：代勤OK') {
        // 重複スタッフは排除
        if (!staff.includes(d.workInsteadStaffDailyCleaning)) {
          target.push(d)
          mobile.push({ name: d.workInstead, mobile: d.numberMobilePhone })
          staff.push(d.workInsteadStaffDailyCleaning)
        }
      }
    }

    // 対象データがある場合のみオープン
    if (target && target.length) {
      const dialogRef = this.dialog.open(SmsDialogComponent, {
        data: {
          target,
          siteName: this.siteName,
          mobile
        }
      });
      return dialogRef.afterClosed().toPromise();
    }
    return Promise.resolve();
  }

  /**
   * RPの概要書別タブで開く
   */
  openOutline() {
    window.open(
      this.RPUrl() + 'SiteOutlineEdit?siteCode=' + this.data['cdSite'],
      '_blank',
      'noopener'
    );
  }

  /**
   * 通常担当者の詳細ダイアログ開く
   */
  openStaffDetail() {
    this.dialog.open(StaffDetailDialogComponent, {
      data: {
        data: {
          staffDailyCleaning: this.data['staffDailyCleaning'],
          cdSite: this.data['cdSite'],
          sequenceNumber: this.data['sequenceNumber'],
        }
      }
    });
  }

  /**
   * 保存ボタンイベント
   */
  async sendWorkInstead() {
    this.saveDisabled = true;
    this.start = new Date(moment(this.start).format('YYYY-MM-DD'));
    this.end = new Date(moment(this.end).format('YYYY-MM-DD'));

    let data = [];

    // 賃金の金額をチェック
    if (this.checkWage()) {
      this.saveDisabled = false;
      return;
    }
    // 交通費の金額をチェック
    if (this.chackTrans()) {
      this.saveDisabled = false;
      return;
    }
    // 実働時間をチェック
    if (this.checkWorkingHours()) {
      this.saveDisabled = false;
      return;
    }
    // 同じ人の時間重複をチェック
    if (this.checkWorkingDuplication()) {
      this.saveDisabled = false;
      return;
    }
    // 引継・指導の代勤が本人の時間帯と重なっているか（重なっていなければ確認。やめたら保存しない）
    if (this.checkTakeOverOverlap()) {
      this.saveDisabled = false;
      return;
    }

    // デフォルト、「連日」の場合
    if (this.displaySpecifyDate == 'consecutive') {
      let startDay = moment(this.start);
      let endDay = moment(this.end);
      let days = endDay.diff(startDay, 'days');
      this.daysSelected = []

      // 終了日が開始日より前だと日が1つも無い（バックで 500 になる）
      if (days < 0) {
        alert('終了日が開始日より前になっています。');
        this.saveDisabled = false;
        return;
      }

      for (let i = 0; i <= days; i++) {
        let dateS = moment(this.start).add(i, 'days').format('YYYY-MM-DD');
        // 日付のみの配列
        this.daysSelected.push(dateS);

        // 代勤データを生成
        for (let j = 0; j < this.workInsteads.length; j++) {
          this.workInsteads[j].day = dateS;
          // アップデートを防ぐため、代勤IDをnullにセット
          // this.workInsteads[j].id = null;
          data.push(Object.assign({},this.workInsteads[j]));
        }
      }
      // this.workInsteads = data;

    // 「複数日指定」の場合
    } else if (this.displaySpecifyDate == 'multiple') {
      // 日を1つも選んでいない（バックで 500 になる）
      if (this.daysSelected.length == 0) {
        alert('日付を選んでください。');
        this.saveDisabled = false;
        return;
      }

      for (let i = 0; i < this.daysSelected.length; i++) {

        // 代勤データを生成
        for (let j = 0; j < this.workInsteads.length; j++) {
          this.workInsteads[j].day = this.daysSelected[i];
          // アップデートを防ぐため、代勤IDをnullにセット
          // this.workInsteads[j].id = null;
          data.push(Object.assign({},this.workInsteads[j]));
        }
      }

    // 「曜日指定」の場合
    } else {
      let startDay = moment(this.start);
      let endDay = moment(this.end);
      let days = endDay.diff(startDay, 'days');
      this.daysSelected = []

      for (let i = 0; i <= days; i++) {
        let date = moment(this.start).add(i, 'days').format('YYYY-MM-DD');
        let weekNumber = new Date(date).getDay();

        // 範囲指定の中に選択した曜日がない場合は処理をスキップ
        for (let j = 0; j < this.week.length; j++) {
          if (this.week[j] == weekNumber) {
            this.daysSelected.push(date);
          }
        }
      }

      if (this.daysSelected.length == 0) {
        alert('該当する日がありません。');
        this.saveDisabled = false;
        return;
      }

      for (let i = 0; i < this.daysSelected.length; i++) {
        // 代勤データを生成
        for (let j = 0; j < this.workInsteads.length; j++) {
          // 日付をセット
          this.workInsteads[j].day = this.daysSelected[i];
          data.push(Object.assign({},this.workInsteads[j]));
        }
      }

    }

    // 契約の終了日の翌日以降の日があれば確認（代勤日が決まってから。やめたら保存しない）
    if (this.checkContractEnd(this.daysSelected)) {
      this.saveDisabled = false;
      return;
    }

    // 代勤日ごとの最低賃金と賃金をチェック（代勤日が決まってから）
    if (this.checkMinWage(this.daysSelected)) {
      this.saveDisabled = false;
      return;
    }

    // 月の契約時間を超えないか確認（代勤日が決まってから。超えるなら確認、やめたら保存しない）
    if (await this.checkMonthOver(this.daysSelected)) {
      this.saveDisabled = false;
      return;
    }

    // 入力したメモを反映
    for (let j = 0; j < data.length; j++) {
      data[j].note = this.note;
    }

    // tbl_operation_note用のデータを生成
    this.setOperationNote(this.daysSelected);

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "X-LoginAccessKey": localStorage.getItem("accessKey")
      })
    };

    // アップデートを防ぐため、代勤IDをnullにセット
    for (let dIdx = 0; dIdx < data.length; dIdx++) {
      let saveData = data[dIdx];
      saveData.id = null;
    }

    this.http.post(
      API_BASE_URL + "/api/v1/operations?days=" + this.daysSelected
        + "&cdSite=" + this.data['cdSite']
        + "&staffDailyCleaning=" + this.data['staffDailyCleaning']
        + "&sequenceNumber=" + this.data['sequenceNumber']
        + "&cdContract=" + this.data['cdContract']
        // 物件名は1行にしたもの（稼働管理の行は現場名2の前で改行している）。清掃員名・表示フラグは行の nameStaff・isShow（ログと休み取り消しのメールに使う）
        + "&nameSite=" + encodeURIComponent(this.siteName || '')
        + "&name=" + encodeURIComponent(this.data['nameStaff'] || '')
        + "&show=" + (this.data['isShow'] || '')
        + "&spot=" + this.spot
        , data
        , httpOptions
    ).subscribe(operations => {
      let msg = '代勤'
      if (this.spot) {
        msg = 'スポット作業'
      }
      alert(`${this.workInsteads.length}件の${msg}を登録しました`);
      // tbl_operation_noteに保存
      this.http.post(
        API_BASE_URL + '/api/v1/operationNote/save?days=' + this.daysSelected, this.operationNote, httpOptions
      ).subscribe(async res => {
        await this.openMailDialog(data);
        // 他の代勤の交通費を更新
        await this.updateInsteadData(operations);
        this.dialogRef.close(true);
      },error => {
        alert("認証に失敗しました");
        this.dialogRef.close(true);
        return;
      });
    },error => {
      if (error.error.status == 800 && error.error.message != ""){
        alert(error.error.message);
        this.saveDisabled = false;
        if (error.error.message == '' || error.error.message.indexOf('SMS') > -1) {
          this.openMailDialog(data);
        }
      } else if (error.error.status == 801){
        alert(error.error.message);
        this.saveDisabled = false;
      } else {
        alert("認証に失敗しました");
        this.router.navigate(['/']);
        this.dialogRef.close();
      }
    });
  }

  /**
   * 他の代勤の交通費を更新するための情報
   * @param data 保存した代勤データ（IDあり）
   */
  async updateInsteadData(data) {
    this.updateCompleteData = false;

    // 代勤者の当日の「代勤確定データ」が複数ある際の全データ
    let oneDayWorkings = []

    // 一度保存されて、削除されたデータで対象のステータスであるもの
    const removeData = this.remove.filter((row) => {
      return row.id && this.routStatus.includes(row.status)
    })

    // 登録したデータで対象のステータスであるもの
    const savedData = data.filter((row) => {
      return this.routStatus.includes(row.status)
    })

    // 同じ日、同じ清掃員での重複削除
    const seen = new Set()
    const all = (removeData.concat(savedData)).filter(row => {
      const key = row.day + '_' + row.workInsteadStaffDailyCleaning
      if (seen.has(key)) return false
      seen.add(key)
      return true
    })

    if (all && all.length) {
      // 該当の日、清掃員の勤務状態を取得
      oneDayWorkings = await this.getInsteadOK(all)
    }

    const changeingTrans = []

    for (let i = 0; i < oneDayWorkings.length; i++) {
      const row = oneDayWorkings[i]
      if (row.oneDayWork) {
        for (let j = 0; j < row.oneDayWork.length; j++) {
          const w = row.oneDayWork[j]
          const before = row.oneDayWork[j - 1]
          const next = row.oneDayWork[j + 1]
          // 通常担当物件以外、休み取り消し以外（休み取り消しは自分の担当物件なので交通費は決まっている）は絶対、さっき保存した代勤データ以外、もしくは同じところでスポット作業・代勤登録している
          if (w.id > 0 && w.status != '休み取り消し' && ((!(row.cdSite == w.cdSite && row.sequenceNumber == w.sequenceNumber)) || ((this.spot && w.status != 'スポット作業') || (!this.spot && w.status == 'スポット作業')))) {
            // 出発地点、次の目的地点が保存されているデータのみ
            if (w.startPoint && w.endPoint) {
              // 出発地点 初期値は清掃員自宅
              let startNameNew = '自宅'
              let start = row.address
              w.startId = null
              // 前勤務に物件がある場合
              if (before) {
                startNameNew = before.nameSite
                start = before.siteAddress
                w.startId = before.id
              }
              // 保存済み代勤の前物件住所が違う場合
              if (w.startPoint != start) {
                w.startDiff = true
              }

              // 次の地点 初期値は清掃員自宅
              let endNameNew = '自宅'
              let end = row.address
              w.endId = null
              // 次勤務に物件がある場合
              if (next) {
                endNameNew = next.nameSite
                end = next.siteAddress
                w.endId = next.id
              }
              // 保存済み代勤の次物件住所が違う場合
              if (w.endPoint != end) {
                w.endDiff = true
              }

              if (w.startDiff || w.endDiff) {
                const param = { startPoint: start, endPoint: end, newAddress: w.siteAddress, startId: w.startId, endId: w.endId }
                // 交通費再取得
                const trans = await this.getTransportation(row.cdStaff, param, row.day, false)

                // マップ生成
                const oldMap = this.getMap(w, w.siteAddress)
                const newMap = this.getMap(param, w.siteAddress)

                if (!trans.noMapMsg && Number(trans.price) != Number(w.transportationExpenses)) {
                  changeingTrans.push({ ...row, ...w, startPointNew: start, endPointNew: end, startNameNew, endNameNew, price: trans.price, oldMap, newMap })
                }
              }
            }
          }
        }
      }
    }
    if (changeingTrans.length) {
      const dialogRef = this.dialog.open(UpdateOtherTransDialogComponent, {
        data: {
          list: changeingTrans
        }
      });
    }
    this.updateCompleteData = true;
  }

  /**
   * 賃金を確認
   */
  checkWage() {
    if (this.workInsteads) {
      for (let i = 0; i < this.workInsteads.length; i++) {
        let name = ''
        if(this.workInsteads[i].workInstead) {
          name = this.workInsteads[i].workInstead + 'さんの';
        }
        // 清掃員は全員時給なので、賃金区分は見ない
        if (!this.workInsteads[i].basicWage) {
          alert(`${name}賃金を入力してください。`);
          return true
        }
        if (this.maxWage < Number(this.workInsteads[i].basicWage)) {
          alert(`賃金が高いです。\r\n${name}賃金を ${this.maxWage}円以下にしてください。`);
          return true
        }
      }
    }
    return false;
  }

  /**
   * 交通費を確認
   */
  chackTrans() {
    let cannotSave = false;

    if (this.workInsteads) {
      for (let i = 0; i < this.workInsteads.length; i++) {
        let name = ''
        if(this.workInsteads[i].workInstead != '') {
          name = this.workInsteads[i].workInstead + ' さんの';
        }
        if (4000 <= Number(this.workInsteads[i].transportationExpenses)) {
          alert(name + "交通費が4,000円以上のため登録できません。");
          cannotSave = true;
          return cannotSave;
        } else if (2000 <= Number(this.workInsteads[i].transportationExpenses)) {
          if (window.confirm(name + "交通費が2,000円以上ですがよろしいでしょうか？")) {} else {return cannotSave = true;}
        }

        // 交通費なしチェック
        if (!this.workInsteads[i].noTransportCost) {
          if (this.workInsteads[i].transportationExpenses == '' || this.workInsteads[i].transportationExpenses == 0 || this.workInsteads[i].transportationExpenses == null) {
            if (window.confirm(name + "交通費はなしでよろしいでしょうか？")) {
              this.workInsteads[i].noTransportCost = true;
              this.workInsteads[i].transportationExpenses = 0;
            } else {
              cannotSave = true;
              return cannotSave;
            }
          }
        }
      }
    }
    return cannotSave;
  }

  /**
   * このダイアログの中で時間帯が重なっていないか確認
   * 同じ人の重なりは止める（引継ぎ・指導の行も同じ。同じ人が同じ時間に 2 行には入れない）。違う人の重なりは確認して、やめたら保存しない
   * （引継ぎの人は代勤者と同じ時間に入るので、違う人どうしは止めずに確認だけにしている）
   * 登録済みのほかの物件との重なりは、バックの checkSaveOperation が見る
   * @returns 保存しないなら true
   */
  checkWorkingDuplication() {
    if (this.workInsteads != null && this.workInsteads.length > 0) {
      const toNum = t => Number(String(t).replace(':', ''));
      const others = [];

      for (let i = 0; i < this.workInsteads.length; i++) {
        const w = this.workInsteads[i];

        for (let i2 = i + 1; i2 < this.workInsteads.length; i2++) {
          const w2 = this.workInsteads[i2];

          // 重なっていない
          if (!(toNum(w2.startTime) < toNum(w.endTime) && toNum(w2.endTime) > toNum(w.startTime))) continue;

          // 同じ人は止める
          if (w.workInsteadStaffDailyCleaning == w2.workInsteadStaffDailyCleaning) {
            alert(`${w.workInstead}さんの時間帯が重なっています。\r\n`
              + `${w.startTime} ～ ${w.endTime} と ${w2.startTime} ～ ${w2.endTime}`);
            return true;
          }
          // 違う人は確認する
          others.push(`${w.workInstead}さん（${w.startTime} ～ ${w.endTime}）と ${w2.workInstead}さん（${w2.startTime} ～ ${w2.endTime}）`);
        }
      }

      if (others.length) {
        return !window.confirm('時間帯がかぶっていますがよろしいでしょうか？\r\n\r\n' + others.join('\r\n'));
      }
    }
    return false;
  }

  /**
   * 引継・指導の代勤が、本人（この行の清掃員）の時間帯と全く重なっていなければ確認する
   * 引継ぎは本人と一緒に入るものなので、時間がずれていれば登録の間違いの可能性が高い。それでもよければ登録は進める
   * 本人の時間帯は開いた日の時間帯（setInitTime の startTime〜endTime。複数日登録でも開いた日で見る）。時間帯が無い日・スポット作業では見ない
   * @returns 保存しないなら true
   */
  checkTakeOverOverlap() {
    if (this.spot || !this.workInsteads || !this.workInsteads.length) return false;
    const toNum = t => Number(String(t).replace(':', ''));
    const selfStart = toNum(this.startTime);
    const selfEnd = toNum(this.endTime);
    // 本人の時間帯が無い（0:00 - 0:00）
    if (!(selfEnd > selfStart)) return false;

    const notOverlap = [];
    for (const w of this.workInsteads) {
      if (!w.takeOver) continue;
      // 重なっている
      if (toNum(w.startTime) < selfEnd && toNum(w.endTime) > selfStart) continue;
      notOverlap.push(`${w.workInstead}さん（${w.startTime} ～ ${w.endTime}）`);
    }

    if (notOverlap.length) {
      return !window.confirm('引継・指導の代勤ですが、本人の時間帯（' + this.startTime + ' ～ ' + this.endTime + '）と重なっていません。\r\n'
        + 'このまま登録しますか？\r\n\r\n' + notOverlap.join('\r\n'));
    }
    return false;
  }

  /**
   * 実働時間を確認
   */
  checkWorkingHours() {
    let cannotSave = false;

    if (this.workInsteads != null  && this.workInsteads.length > 0) {
      for (let i = 0; i < this.workInsteads.length; i++) {
        // 空のまま保存するとバックで数字に変換できず落ちる（開始・終了を変えれば自動で入る）
        const hours = this.workInsteads[i].workingHours;
        if (hours === '' || hours === null || hours === undefined) {
          alert(this.workInsteads[i].workInstead + 'さんの実働時間を入力してください。');
          return true;
        }
        // 対象のステータスの場合
        if (this.routStatus.includes(this.workInsteads[i].status)) {
          let sTime = moment(this.day + ' ' + this.workInsteads[i].startTime + ':00');
          let eTime = moment(this.day + ' ' + this.workInsteads[i].endTime + ':00');
          let diff = eTime.diff(sTime, 'minute');
          diff = diff / 60;
          // 開始、終了時間の差よりも入力された実働時間が長い場合はアラートを表示
          if (this.workInsteads[i].workingHours > diff) {
            let name = '';
            name = this.workInsteads[i].workInstead + 'さんの';
            alert(name + '実働時間が開始~終了時間（' + diff + '時間）よりも長いです。');
            cannotSave = true;
          }
        }
      }
    }
    return cannotSave;
  }

  /**
   * 月・日の契約時間を超えないか確認（月次確認の時間差分と同じ決まり。確定＝●OK・休み取り消し。引継ぎ・指導とスポットは数えない）
   * 月ごとに：月の時間差（プラスが超過） − その月の代勤日にこの行で登録済みの確定の代勤の実働 ＋ 今回保存する確定の代勤の実働 × その月の代勤日の数
   * 日ごとに：その日の物件の時間差（プラスが超過） − その日にこの行で登録済みの確定の代勤の実働 ＋ 今回保存する確定の代勤の実働
   * 登録済みの代勤は表に読み込まれて保存でも送られるので、時間差に入っている分を一度引いて、表の今の値で足し直す
   * 0 より大きい月・日があれば、月と日を並べて1回の確認を出す。時間差が取れなかった月は知らせるだけで止めない
   * API: operations/monthDiffCheck
   * @param days 代勤日（YYYY-MM-DD）
   * @returns 登録をやめるなら true
   */
  async checkMonthOver(days: string[]): Promise<boolean> {
    // 今回保存する確定の代勤の実働（1日あたり）。無ければ超過は増えないので見ない
    let newHours = 0;
    for (let i = 0; i < this.workInsteads.length; i++) {
      const w = this.workInsteads[i];
      if (this.okStatus.includes(w.status) && !w.takeOver) {
        newHours += Number(w.workingHours) || 0;
      }
    }
    if (newHours <= 0 || !days || !days.length) {
      return false;
    }

    let res;
    try {
      res = await this.http.get(
        API_BASE_URL + '/api/v1/operations/monthDiffCheck?cdSite=' + encodeURIComponent(this.data['cdSite'])
          + '&staffDailyCleaning=' + encodeURIComponent(this.data['staffDailyCleaning'])
          + '&sequenceNumber=' + encodeURIComponent(this.data['sequenceNumber'])
          + '&days=' + days.join(','),
        {headers: this.headers}
      ).toPromise();
    } catch (error) {
      if (error && (error.status == 401 || error.status == 403)) {
        alert("認証に失敗しました");
        this.router.navigate(['/']);
        return true;
      }
      alert('契約時間との時間差分を取得できませんでした。\r\n（契約時間を超えないかの確認はできません）');
      return false;
    }
    const months = (res && res['months']) || {};
    const dayDiffs = (res && res['days']) || {};
    const existing = (res && res['existing']) || {};

    // 月ごとの代勤日の数
    const dayCount = {};
    for (let i = 0; i < days.length; i++) {
      const m = days[i].substring(0, 7);
      dayCount[m] = (dayCount[m] || 0) + 1;
    }

    const over = [];
    const failed = [];
    const monthKeys = Object.keys(dayCount).sort();
    for (let i = 0; i < monthKeys.length; i++) {
      const m = monthKeys[i];
      const label = moment(m + '-01').format('YYYY年M月');
      if (months[m] === null || months[m] === undefined) {
        failed.push(label);
        continue;
      }
      let existingHours = 0;
      for (let j = 0; j < days.length; j++) {
        if (days[j].substring(0, 7) == m) {
          existingHours += Number(existing[days[j]]) || 0;
        }
      }
      const projected = Number(months[m]) - existingHours + newHours * dayCount[m];
      if (projected > 0) {
        over.push(label + '：' + (Math.round(projected * 100) / 100) + ' 時間');
      }
    }

    // 日ごと：その日の物件の時間差 − この行の登録済み ＋ 今回保存する分
    const overDays = [];
    const sortedDays = days.slice().sort();
    for (let i = 0; i < sortedDays.length; i++) {
      const d = sortedDays[i];
      const projected = (Number(dayDiffs[d]) || 0) - (Number(existing[d]) || 0) + newHours;
      if (projected > 0) {
        overDays.push(moment(d).format('YYYY/MM/DD') + '：' + (Math.round(projected * 100) / 100) + ' 時間');
      }
    }

    if (failed.length) {
      alert(failed.join('、') + ' の契約時間との時間差分を取得できませんでした。\r\n（その月は契約時間を超えないかの確認はできません）');
    }
    if (!over.length && !overDays.length) {
      return false;
    }
    let msg = '契約時間よりも時間が多くなります。\r\n';
    // 見出しに「（月）」「（日）」と書くと曜日に見えるので、「月ごと」「日ごと」にする
    if (over.length) {
      msg += '\r\n月ごとの超過する時間\r\n' + over.join('\r\n') + '\r\n';
    }
    if (overDays.length) {
      msg += '\r\n日ごとの超過する時間\r\n' + overDays.join('\r\n') + '\r\n';
    }
    return !window.confirm(msg + '\r\n登録してもよろしいでしょうか？');
  }

  /**
   * 閉じるボタンイベント
   */
  close() {
    this.dialogRef.close();
  }
}
